import { render, staticRenderFns } from "./BaseSliderWithGallery.vue?vue&type=template&id=5070a472&scoped=true&"
import script from "./BaseSliderWithGallery.vue?vue&type=script&lang=js&"
export * from "./BaseSliderWithGallery.vue?vue&type=script&lang=js&"
import style0 from "./BaseSliderWithGallery.vue?vue&type=style&index=0&id=5070a472&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070a472",
  null
  
)

export default component.exports